import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Dashboard from './pages/Dashboard/Dashboard';
import EventDetail from './components/Event/EventDetail';
import Login from './pages/Login/Login';
import AdminEventsView from './pages/Admin/AdminEventsView';
import MembershipForm from './pages/Membership/MembershipForm';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/event/:id" element={<EventDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/eventsadmin" element={<AdminEventsView />} />
        <Route path="/membershipsignup" element={<MembershipForm />} />
      </Routes>
    </Router>
  );
}

export default App;